import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations, LOCALES } from "@/i18n/translations";

const LanguageContext = createContext(null);

const STORAGE_KEY = "othryx.lang";

export function LanguageProvider({ children }) {
    const [lang, setLangState] = useState(() => {
        if (typeof window === "undefined") return "en";
        const saved = window.localStorage.getItem(STORAGE_KEY);
        return saved && LOCALES.includes(saved) ? saved : "en";
    });

    const dir = translations[lang].meta.dir;

    useEffect(() => {
        document.documentElement.lang = lang;
        document.documentElement.dir = dir;
        window.localStorage.setItem(STORAGE_KEY, lang);
    }, [lang, dir]);

    const value = useMemo(
        () => ({
            lang,
            dir,
            setLang: (next) => LOCALES.includes(next) && setLangState(next),
            t: translations[lang],
            locales: LOCALES.map((code) => ({
                code,
                ...translations[code].meta,
            })),
        }),
        [lang, dir]
    );

    return (
        <LanguageContext.Provider value={value}>
            {children}
        </LanguageContext.Provider>
    );
}

export function useLang() {
    const ctx = useContext(LanguageContext);
    if (!ctx) throw new Error("useLang must be used within LanguageProvider");
    return ctx;
}
